import React from "react"

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info)
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback
      return (
        <div className="ui-card p-6" role="alert">
          <p className="m-0 font-semibold text-ink">Something went wrong loading this section.</p>
          <p className="m-0 mt-2 text-sm text-muted">Refresh the page to try again.</p>
        </div>
      )
    }

    return this.props.children
  }
}
